var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider",class:{
    'horizontal-line': _vm.hasLine && !_vm.vertical,
    'vertical-line': _vm.hasLine && _vm.vertical
  },style:({
    height: _vm.vertical ? '100%' : `${_vm.dividerSize}px`,
    width: !_vm.vertical ? '100%' : `${_vm.dividerSize}px`
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }